module.exports = __webpack_public_path__ + "img/productsUpsell.4ebd9878.svg";